var _path, _rect, _rect2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89325 4.03288H3.6075C1.3275 4.03288 0 5.36788 0 7.65538V14.4029C0 16.7279 1.3275 18.0329 3.6075 18.0329H9.89325C12.21 18.0329 13.5 16.7279 13.5 14.4029V7.65538C13.5 5.36788 12.21 4.03288 9.89325 4.03288Z",
    fill: "#C670B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.53052,
    y: 1.34746,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "#C670B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53052,
    y: 1.34746,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0305 7.84746C9.8935 7.84746 9.78809 7.81057 9.71431 7.73679C9.64053 7.65773 9.60364 7.5497 9.60364 7.41267V6.23481H8.44949C8.31774 6.23481 8.21497 6.20055 8.14119 6.13204C8.06741 6.05826 8.03052 5.95549 8.03052 5.82374C8.03052 5.69199 8.06741 5.59186 8.14119 5.52335C8.21497 5.44957 8.31774 5.41268 8.44949 5.41268H9.60364V4.28224C9.60364 4.13995 9.64053 4.03191 9.71431 3.95813C9.78809 3.88435 9.89613 3.84746 10.0384 3.84746C10.1754 3.84746 10.2782 3.88435 10.3467 3.95813C10.4205 4.03191 10.4574 4.13995 10.4574 4.28224V5.41268H11.6115C11.7486 5.41268 11.8513 5.44957 11.9198 5.52335C11.9936 5.59186 12.0305 5.69199 12.0305 5.82374C12.0305 5.95549 11.9936 6.05826 11.9198 6.13204C11.8513 6.20055 11.7486 6.23481 11.6115 6.23481H10.4574V7.41267C10.4574 7.5497 10.4205 7.65773 10.3467 7.73679C10.2782 7.81057 10.1728 7.84746 10.0305 7.84746Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71606 15.4264H2.72356C2.72356 15.7497 2.98606 16.0114 3.30856 16.0114C3.63106 16.0114 3.89356 15.7497 3.89356 15.4264V14.1846C3.89356 13.8614 3.63106 13.5989 3.30031 13.5989C2.97856 13.5989 2.71606 13.8614 2.71606 14.1846V15.4264ZM7.28356 11.5464V15.4264C7.28356 15.7497 7.02107 16.0114 6.69857 16.0114C6.37606 16.0114 6.11281 15.7497 6.11281 15.4264V11.5464C6.11281 11.2239 6.37606 10.9614 6.69857 10.9614C7.02107 10.9614 7.28356 11.2239 7.28356 11.5464ZM10.7111 11.5464V15.4264C10.7411 15.6514 10.6286 15.8689 10.4411 15.9889C10.2461 16.1089 9.99856 16.1089 9.81106 15.9889C9.61606 15.8689 9.51107 15.6514 9.53357 15.4264V11.5464C9.56357 11.2471 9.81856 11.0214 10.1261 11.0214C10.4253 11.0214 10.6811 11.2471 10.7111 11.5464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateInvoice);
export default __webpack_public_path__ + "static/media/generateInvoice.12a3a7c7c094d9689cb5978aceb7081d.svg";
export { ForwardRef as ReactComponent };